import ServiceStore from "stores/ServiceStore";
import { RouteType } from "types/RouteType";

const DeliveryConfirmationWorkflowRoute: RouteType = {
  name: "Delivery Confirmation Workflow",
  path: "/workflows/delivery-confirmation",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Delivery Confirmation & POD Upload",
      component: () => import("./DeliveryConfirmationWorkflowHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./DeliveryConfirmationWorkflow"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      // Load necessary data for the wizard
      const loadStore = rootStore.loadStore as ServiceStore;
      const documentManagementStore = rootStore.documentManagementStore as ServiceStore;
      const azureBlobStorageStore = rootStore.azureBlobStorageStore as ServiceStore;
      const invoicesStore = rootStore.invoicesStore as ServiceStore;

      await Promise.all([
        loadStore?.find(),
        documentManagementStore?.find(),
        azureBlobStorageStore?.find(),
        invoicesStore?.find(),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load data for delivery confirmation:", error);
      return false;
    }
  },
  onExit: ({ rootStore }) => {
    const store = (rootStore as any).deliveryConfirmationWorkflowStore;
    store?.reset();
  },
};

export default DeliveryConfirmationWorkflowRoute;